import React, {useContext} from "react";
import {PopupStyles} from './styles'
import { ThemeContext } from "providers/ThemeProvider"


const Popup = props => {
  const { theme } = useContext(ThemeContext);

  return (
    <PopupStyles theme={theme}>
    <div className="popup-box"theme={theme} >
      <div className="box" theme={theme}>
        <span role="button" className="close-icon" onClick={props.handleClose} onKeyDown={props.handleClose}>x</span>
        <>
<p dir="ltr" id="docs-internal-guid-506f66fd-7fff-0642-c4aa-f4c5e9f7eba2">
    POLITICA DE CONFIDENTIALITATE A SITE-ULUI GPOAUTO.RO
</p>
<p dir="ltr">
    PROTECTIA PERSOANELOR CU PRIVIRE LA PRELUCRAREA DATELOR CU CARACTER
    PERSONAL
</p>
<p dir="ltr">
    gpoauto.ro se angajeaza sa nu transmita datele personale ale utilizatorilor
    site-ului catre terti si sa le foloseasca numai in scopul stabilirii
    contactului cu clientii sai, precum si in scopul informarii acestora asupra
    aspectelor legate de functionarea site-ului si a ofertelor acestuia.
</p>
<p dir="ltr">
    Compania va retine datele personale si le va folosi in scopul informarii
    utilizatorilor si pentru comunicarea cu acestia priviind serviciilor
    oferite.
</p>
<p dir="ltr">
    gpoauto.ro nu promoveaza SPAM-ul. Orice utilizator care a furnizat explicit
    adresa sa de email pe site-ul gpoauto.ro, poate opta pentru stergerea
    acesteia din baza noastra de date.
</p>
<p dir="ltr">
    De asemenea, daca utilizatorii nu mai doresc sa primeasca eventuale mesaje
    sau informatii, se pot dezabona direct prin email la hr10gpo(@)gmail.com.
</p>
<p dir="ltr">
    SECURITATEA DATELOR PERSONALE
</p>
<p dir="ltr">
    Confidentialitatea datelor tale cu caracter personal este importanta pentru
    noi. Acest angajament de respectare a confidentialitatii iti explica ce
    date cu caracter personal colecteaza gpoauto.ro de la tine, prin
    intermediul interactiunilor noaste si modul in care utilizam datele
    respective.
</p>
<p dir="ltr">
    CINE SUNTEM
</p>
<p dir="ltr">
    Datele noastre de identificare sunt urmatoarele:
</p>
<p dir="ltr">
    Nume: Palfi Gaspar Csaba PFA
</p>
<p dir="ltr">
    CUI: 23320004
</p>
<p dir="ltr">
    Adresa Nr. 567 SATU MARE, JUD. HARGHITA
</p>
<p dir="ltr">
    Telefon: +40 751-126-339
</p>
<p dir="ltr">
    Email: hr10gpo(@)gmail.com
</p>
<p dir="ltr">
    Prin „date personale” se denumesc informatiile unice individuale privind o
    persoana fizica identificata sau identificabila („persoana vizata”),
    referitoare la nume, adresa, cod numeric personal, IP sau numar de telefon,
    date de localizare, un identificator online sau la unul sau mai multe
    elemente specifice, proprii identitatii sale fizice, fiziologice, genetice,
    psihice, economice, culturale sau sociale.
</p>
<p dir="ltr">
    De fiecare data cand solicitam datele tale personale o sa iti explicam
    scopul pentru care ne sunt necesare, unde pastram datele tale si cine are
    acces la acestea. Bineinteles, te informam ca oricand doresti, iti punem la
    dispozitie informatiile pe care le detinem despre tine si bineinteles ca le
    vom sterge daca ne soliciti acest lucru.
</p>
<p dir="ltr">
    Ce date personale colectam si de ce le colectam
</p>
<p dir="ltr">
    Colectam date cu caracter personal pentru a putea raspunde cu succes
    solicitarilor tale. Furnizezi unele din aceste date direct, de exemplu,
    atunci cand ne scrii un mesaj prin intermediul formularului de contact sau,
    indirect, date de identificare prin adresa ta IP. Noi nu folosim adresa ta
    IP pentru a te identifica, dar te informam ca aceasta este stocata in
    momentul in care accesezi site-ul nostru – in principal din motive de
    securitate. Ai dreptul de a solicita stergerea IP-ului!
</p>
<p dir="ltr">
    In functie de interactiunile pe care le ai cu site-ul nostru, datele cu
    caracter personal pe care le colectam sunt urmatoarele:
</p>
<ul>
    <li dir="ltr">
        <p dir="ltr">
            Nume si prenume – pentru identificare;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Adresa de email – pentru comunicare;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Numar de telefon – pentru comunicare;
        </p>
    </li>
    <li dir="ltr">
        <p dir="ltr">
            Mesaj – Camp in care poti expune problema sau intrebarea ta.
        </p>
    </li>
</ul>
<p dir="ltr">
    Datele cu caracter personal solicitate in momentul transmiterii mesajului
    sunt folosite DOAR pentru a putea lua legatura cu tine si a raspunde
    cererii tale. Ulterior vor fi solicitate si date prevazute de codul fiscal
    pentru facturare daca este cazul.
</p>
<p dir="ltr">
    Date transmise involuntar, atunci cand interactionezi cu websitul nostru:
</p>
<p dir="ltr">
    Adresa IP– Atunci cand vizitezi situl nostru, adresa IP este inregistrata.
    Insa noi NU folosim adresa ta de IP pentru a te identifica sau pentru a fi
    folosita in alte scopuri.
</p>
<p dir="ltr">
    Sistemul de operare, browserul, activitatea de navigare si alte informatii
    despre modul in care ai interactionat cu site-ul. Putem colecta aceste
    informatii prin folosirea cookie-urilor sau a altor tehnologii similare.
</p>
<p dir="ltr">
    Cookie-uri
</p>
<p dir="ltr">
    Folosim doar cookie-uri pentru statistici, cookie-uri ce pot fi dezactivate
    direct din browser-ul tau. Cookie-urile de statistica ii ajuta pe
    proprietarii unui site sa inteleaga modul in care vizitatorii
    interactioneaza cu site-urile prin colectarea si raportarea informatiilor
    in mod anonim. Furnizorii de servicii cu care colaboram pentru a masura
    traficul site-ului este Google Analytics.
</p>
<p dir="ltr">
    Care este temeiul legal pentru prelucrarea acestor date?
</p>
<p dir="ltr">
    Datele pe care ni le oferi voluntar (nume, prenume, adresa, telefon, adresa
    de email) – temeiul legal este acela de a face demersuri la cererea
    persoanei vizate inainte de incheierea unui contract (art. 6 alin. (1) lit.
    bsi c din Regulamentul (UE) 679/2016).
</p>
<p dir="ltr">
    In privinta datelor pe care le colectam automat prin folosirea
    cookie-urilor sau a altor tehnologii similare, temeiul pentru prelucrare
    este consimtamantul. Odata cu accesarea site-ului, si selectarea optiunii
    DA/De acord iti dai in mod valabil consimtamantul asupra prelucrarii.
</p>
<p dir="ltr">
    Care este scopul colectarii datelor si cum folosim informatiile tale
    personale
</p>
<p dir="ltr">
    Poti opta in legatura cu datele pe care le colectam. Atunci cand ti se
    solicita sa furnizezi date cu caracter personal, ai dreptul sa refuzi. Daca
    alegi sa nu furnizezi date care sunt necesare pentru a furniza un serviciu
    sau pentru a comunica cu noi, exista posibilitatea sa nu poti obtine
    informatiile pe care le doresti.
</p>
<p dir="ltr">
    Numele si prenumele
</p>
<p dir="ltr">
    Cum iti folosim numele si prenumele? – Pentru contactul cu tine, pentru
    detectarea si prevenirea fraudelor si pentru asistenta client.
</p>
<br/>
<p dir="ltr">
    De ce iti folosim numele si prenumele? – Este necesar ca tu sa ne furnizezi
    anumite date personale pentru a putea incepe comunicarea. De asemenea,
    pentru a preveni folosirea datelor tale de catre alti utilizatori, este
    necesar sa iti trimitem email-uri pentru a-ti confirma identitatea. Nu in
    ultimul rand pentru a oferi servicii de relatii cu clientii si servicii de
    asistenta (detalii) fie direct, fie prin telefon.
</p>
<p dir="ltr">
    Informatii despre telefon, laptop sau tableta si despre cum folosesti
    site-ul
</p>
<p dir="ltr">
    Informatiile pe care ni le dai cand navighezi pe site-ul nostru, inclusiv
    adresa IP si tipul dispozitivului. Totodata, salvam informatii despre modul
    in care folosesti site-ul si aplicatia.
</p>
<p dir="ltr">
    Cum folosim informatiile despre telefonul, laptop-ul sau tableta ta si
    despre cum folosesti site-ul:
</p>
<p dir="ltr">
    Imbunatatim experienta ta pe site, oferindu-ti versiunea cel mai bine
    adaptata dispozitivului tau.
</p>
<p dir="ltr">
    Protejam site-ul
</p>
<br/>
<p dir="ltr">
    De ce?
</p>
<p dir="ltr">
    Oferirea celei mai bune experiente de navigare pe site.
</p>
<p dir="ltr">
    Pentru a preveni si a detecta fraudele impotriva ta sau a site-ului nostru.
    Pentru a putea asigura confidentialitatea datelor.
</p>
<p dir="ltr">
    Nu esti obligat sa ne oferi niciuna din informatiile de mai sus, insa daca
    nu faci asta, s-ar putea sa nu ai posibilitatea de a te bucura de deplina
    experienta de navigare pe site-ul nostru si pentru serviciile pe care ti le
    punem la dispozitie.
</p>
<p dir="ltr">
    Perioada de retentie a datelor
</p>
<p dir="ltr">
    Stocam datele cu caracter personal doar pe perioada necesara indeplinirii
    scopurilor, dar numai pana la momentul in care hotarasti sa optezi in scris
    la office@gpoauto.ro pentru stergerea acestor date. In cazul in care ti-am
    emis o factura sau ai comunicat cu noi prin formularele de contact pe care
    ti le oferim, datele tale vor fi stocate timp de 10 ani, conform legii.
</p>
<p dir="ltr">
    Cu cine partajam datele cu caracter personal?
</p>
<p dir="ltr">
    Nu vom dezvalui informatiile tale catre terte parti, pentru a fi utilizate
    in propriile scopuri de marketing sau comerciale ale acestora, fara
    consimtamantul tau.
</p>
<p dir="ltr">
    Totusi, este posibil sa dezvaluim informatiile tale catre urmatoarele
    entitati:
</p>
<p dir="ltr">
    Furnizori de servicii. Putem dezvalui informatiile tale altor companii care
    ne furnizeaza servicii si actioneaza in calitate de persoane imputernicite,
    cum ar fi companiile care ne ajuta pentru facturare, companiilor care se
    ocupa de mentenanta website-ului sau care trimit email-uri in numele
    nostru.
</p>
<p dir="ltr">
    Aceste entitati sunt selectate cu o grija deosebita pentru a ne asigura ca
    indeplinesc cerintele specifice in materie de protectie a datelor cu
    caracter personal. Aceste entitati au o capacitate limitata de a utiliza
    informatiile tale in alte scopuri decat cel de a ne furniza servicii.
</p>
<p dir="ltr">
    Informatiile oferite de tine, ce contin date de identificare pot fi
    folosite in scopul intocmirii documentelor de angajare si a altor documente
    ce vizeaza exclusiv relatiile de munca sau pentru comunicari comerciale sau
    raspunsuri la solicitarile trimise de tine, iar in cazul unor solicitari
    legitime, vor fi transmise catre autoritatile statului: Inspectoratul
    Teritorial de Munca, Agentia pentru ocuparea Fortelor de Munca, Autoritati
    Judecatoresti, altor parti cu consimtamantul sau la instructiunile tale.
</p>
<p dir="ltr">
    In afara dezvaluirilor descrise in prezenta Politica de confidentialitate,
    este posibil sa transmitem informatiile tertilor carora consimti sau
    soliciti sa efectuam o asemenea dezvaluire.
</p>
<p dir="ltr">
    Ce drepturi ai ca persoana vizata?
</p>
<p dir="ltr">
    Protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu
    caracter personal este un drept fundamental. Articolul 8 alineatul (1) din
    Carta drepturilor fundamentale a Uniunii Europene („carta”) și articolul
    16 alinea¬tul (1) din Tratatul privind funcționarea Uniunii Europene
    (TFUE) prevăd dreptul oricărei persoane la protecția datelor cu caracter
    personal.
</p>
<p dir="ltr">
    Drepturile persoanelor vizate privind protectia persoanelor cu privire la
    prelucrarea datelor cu caracter personal si libera circulatie a acestor
    date: dreptul la informare si acces; dreptul de interventie asupra datelor;
    dreptul la rectificare; dreptul la stergerea datelor; dreptul la
    restrictionarea prelucrarii; dreptul la portabilitatea datelor; dreptul de
    opozitie si procesul decizional individual automatizat, inclusiv crearea de
    profiluri; dreptul de a depune o plangere in fata autoritatii de
    supraveghere (www.dataprotection.ro).
</p>
<p dir="ltr">
    gpoauto.ro prelucreaza datele dumneavoastra cu caracter personal, prin
    mijloace automatizate si manuale, destinate emiterii facturilor, colectarii
    creantelor legate de acestea precum si furnizarii de informatii legate de
    activitatea acesteia.
</p>
<p dir="ltr">
    Acceptarea termenilor si conditiilor de utilizare a site-ului reprezinta
    acceptul dumneavoastra de prelucrare a datelor personale. Refuzul
    dumneavoastra determina imposibilitatea furnizarii serviciilor.
</p>
<p dir="ltr">
    Informatiile inregistrate sunt destinate utilizarii de catre gpoauto.ro si
    sunt comunicate numai urmatorilor destinatari: persoanelor vizate (clienti
    gpoauto.ro).
</p>
<p dir="ltr">
    Conform Legii nr. 677/2001 si al OUG 34/2014 pentru protectia persoanelor
    cu privire la prelucrarea datelor cu caracter personal si libera circulatie
    a acestor date, beneficiati de dreptul de acces, de interventie asupra
    datelor si de dreptul de a nu fi supus unei decizii individuale. Totodata,
    aveti dreptul sa va opuneti prelucrarii datelor personale care va privesc
    si sa solicitati stergerea datelor. Pentru exercitarea acestor drepturi, va
    puteti adresa cu o cerere scrisa, datata si semnata la gpoauto.ro. De
    asemenea, va este recunoscut dreptul de a va adresa justitiei. Datele
    dumneavoastra nu vor fi transferate tertilor.
</p>
<p dir="ltr">
    Datele personale furnizate catre gpoauto.ro vor fi folosite numai in scopul
    declarat al acestui site, respectiv comanda, executia si livrarea de bunuri
    si servicii, conform legilor in vigoare. Gpoauto.ro nu furnizeaza adresa de
    e-mail unor terti, nu incurajeaza spam-urile si nu face publice datele
    furnizate de clientii sai fara acordul explicit al acestora. Orice client
    are posibilitatea de a sterge din baza de date adresa de e-mail furnizata.
</p>
<p dir="ltr">
    gpoauto.ro nu este responsabil pentru daune care apar sau pot apare ca
    urmare a neglijentei cumparatorului privind securitatea si
    confidentialitatea navigarii sale pe site-ul nostru.
</p>
<br/>
<br/>
</>

    </div>
    </div>
    </PopupStyles>
  );
};

export default Popup;